<template>
  <v-container>
    <div
      :class="{ 'available-text-mobile': $vuetify.breakpoint.mdAndDown }"
      class="appointments px-0"
    >
      Available appointments
    </div>
    <v-row v-if="bookingTypes && bookingTypes.length > 0">
      <v-col
        v-for="(item, id) in bookingTypes"
        :key="id"
        :cols="12 / itemsPerRow"
      >
        <v-card outlined>
          <v-card-title class="pa-0 d-flex justify-space-between">
            <v-col :cols="$vuetify.breakpoint.mdmAndUp ? 10 : 9" class="pa-0">
              <v-card-title class="appointment-type-title py-2">
                {{ item.title }}
              </v-card-title>
            </v-col>
            <v-col
              :cols="$vuetify.breakpoint.mdmAndUp ? 2 : 3"
              class="pa-0 d-flex align-center justify-end px-2"
            >
              <v-icon size="18" class="mdi mdi-currency-gbp"></v-icon>
              <span>{{ parseInt(item.fees, 0) / 100 }}</span>
            </v-col>
          </v-card-title>
          <v-card-title class="appointment-type-subtitle text-decoration py-0">
            {{ item.description }}
          </v-card-title>
          <v-card-subtitle class="appointment-type-subtitle  px-4 py-0 mt-2">
            <span>{{ item.workplaces[0].addressName }}</span>
          </v-card-subtitle>
          <v-row class="px-1 ma-0">
            <v-col class="d-flex justify-space-between card-font-size">
              <span
                ><v-icon
                  small
                  class="mdi mdi-clock-time-five-outline icon"
                ></v-icon>
                {{ item.duration }} Minutes</span
              >
              <v-tooltip
                v-if="
                  item.availability[0].name &&
                    item.availability[0].name.includes('Days')
                "
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span
                    style="cursor: pointer"
                    class="availabilty-name"
                    v-on="on"
                    >{{ item.availability[0].name }}</span
                  ><br />
                </template>
                <div>
                  {{ `${item.availability.map(item => item.day)}` }}
                </div>
              </v-tooltip>
              <span
                v-else-if="item.availability[0].name"
                class="availabilty-name"
                >{{ item.availability[0].name }}</span
              >
              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on }">
                  <span
                    style="cursor: pointer"
                    class="availabilty-name"
                    v-on="on"
                  >
                    {{
                      `Days | ${item.availability[0].slot.startHour} - ${item.availability[0].slot.endHour}`
                    }}</span
                  >
                </template>
                <div>
                  {{ `${item.availability.map(item => item.day)}` }}
                </div>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else class="py-3">
      <v-col cols="12" class="px-0">
        <v-alert
          v-model="alert"
          color="warning"
          border="left"
          elevation="2"
          colored-border
          icon="mdi-timetable"
          class="mx-3"
        >
          Doctor did not set up the appointment type.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from "moment";
export default {
  name: "Availability",
  props: {
    address: Object,
    bookingTypes: Array
  },
  data() {
    return {
      alert: true,
      drawer: true
    };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    itemsPerRow() {
      // eslint-disable-next-line default-case
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 1;
        case "md":
          return 1;
        case "lg":
          return 2;
        case "xl":
          return 3;
      }
    }
  },
  methods: {
    convertTimeFormate(time) {
      return moment(time).format("hh:mm a");
    }
  }
};
</script>
<style scoped type="css">
.appointments {
  font-weight: 500;
  font-size: 18px;
  color: #27445b;
}
.available-text-mobile {
  color: #677c95;
  font-weight: 400;
  font-size: 16px;
}
.appointment-type-title {
  font-family: "Now Alt";
  font-weight: 500;
  font-size: 16px;
  color: #27445b;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 38px;
}
.appointment-type-subtitle {
  font-family: "Now Alt";
  font-weight: 300;
  font-size: 14px;
  color: #27445b;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
}
.icon-cursor {
  cursor: pointer;
}
.availabilty-name {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.text-decoration {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #122d4f;
  height: 54px;
}
.card-font-size {
  font-family: "Now Alt";
  font-weight: 400;
  font-size: 12px;
  color: #677c95;
}
.icon {
  padding-bottom: 6px;
}
</style>
